// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { getCurrencySymbol } from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import { getProductDetails } from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import CONSTANTS from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import { BRANDS } from '@tcp/core/src/constants/Adobe.constants';
import GiftServices from '../views/GiftServices.view';
import GiftServicesSPC from '../views/GiftServicesSPC.view';
import {
  getDetailsContent,
  getGiftWrapOptions,
  getInitialGiftWrapOptions,
  getShippingSelected,
  supressGiftServicesOnLoad,
} from './GiftServices.selector';
import { getBrand, isCanada } from '../../../../../../../../../utils';
import BagPageSelector, {
  isMixedOrderStatus,
} from '../../../../../../BagPage/container/BagPage.selectors';
import BAG_PAGE_ACTIONS from '../../../../../../BagPage/container/BagPage.actions';
import {
  giftDetailsModalModuleXContent,
  giftDetailsSnjModalModuleXContent,
  giftDetailsGymModalModuleXContent,
  giftDetailsPjpModalModuleXContent,
  getSfsError,
} from '../../../../../../SinglePageCheckout/container/SinglePageCheckout.selector';
import {
  addSFSItemsToSFL,
  fetchGiftDetailsModalContentModuleX,
  setSFSErrors,
} from '../../../../../../SinglePageCheckout/container/SinglePageCheckout.actions';
import logger from '../../../../../../../../../utils/loggerInstance';
import { getIsSnjPjpBrandGiftServicesDisabled } from '../../../../../../../../../reduxStore/selectors/session.selectors';
import { getDynamicLabelValues } from '../../../../../../../../../utils/labels/labelUtilty';

class GiftServicesContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    const { giftWrap, cartOrderItems } = this.props;
    const productsData = [];
    if (cartOrderItems) {
      cartOrderItems.map((tile) => {
        const productDetail = getProductDetails(tile);
        const {
          itemInfo: { itemId, color, name, offerPrice, size, listPrice, qty },
          productInfo: { skuId, upc, productPartNumber, generalProductId },
        } = productDetail;

        const prodData = {
          color,
          id: itemId,
          name,
          price: offerPrice,
          extPrice: offerPrice,
          listPrice,
          partNumber: productPartNumber,
          size,
          upc,
          sku: skuId.toString(),
          quantity: qty,
          colorId: generalProductId,
          pricingState: offerPrice < listPrice ? 'on sale' : 'full price',
        };
        productsData.push(prodData);
        return prodData;
      });
    }
    this.state = {
      brandState: giftWrap ? giftWrap.get('brand') : '',
      orderItems: productsData,
    };
  }

  componentDidMount() {
    const { dispatch, supressGiftServicesOnLoadApp } = this.props;
    const brand = this.getBrandForGiftServices();
    if (dispatch) {
      dispatch(change('GiftServices', `brand`, brand));
    }
    if (supressGiftServicesOnLoadApp) this.getGiftServicesDetailsModalContent();
  }

  getBrandForGiftServices = () => {
    const { brandState } = this.state;
    const { savedGiftService } = this.props;
    let brand = '';
    if (brandState) {
      brand = brandState;
    } else if (savedGiftService?.brand) {
      brand = savedGiftService?.brand;
    } else {
      brand = getBrand().toUpperCase();
    }
    return brand;
  };

  /**
   * Get list of gift services available for a brand
   *
   * @param {string} brandName
   * @returns brandOptions
   */
  getBrandOptions = (brandName) => {
    try {
      const { giftWrapOptions } = this.props;
      return JSON.parse(giftWrapOptions)?.giftOptions?.filter(
        (giftOption) => giftOption.itemBrand === 'ALL' || giftOption.itemBrand === brandName
      );
    } catch (e) {
      logger.error('Error in parsing gift service options', e);
      return [];
    }
  };

  /**
   * Get default gift service option to be selected based on brand
   *
   * @param {string} brandName
   * @returns defaultOptionId
   */
  getDefaultOptionId = (brandName, activeGiftName) => {
    const { giftWrapOptions } = this.props;
    let defaultOptionId = 'standard';
    const brandOptions = this.getBrandOptions(brandName);
    const selectedBrandValue =
      activeGiftName && brandOptions?.find((giftItem) => giftItem.name === activeGiftName);
    if (selectedBrandValue && selectedBrandValue?.catEntryId) {
      defaultOptionId = selectedBrandValue?.catEntryId;
    } else if (giftWrapOptions && brandOptions && brandOptions.length) {
      defaultOptionId = brandOptions[0]?.catEntryId;
    }
    return defaultOptionId;
  };

  handleToggle = (e, brandName, activeGiftName) => {
    const { dispatch } = this.props;
    if (dispatch) {
      const defaultOptionId = this.getDefaultOptionId(brandName, activeGiftName);
      dispatch(change('GiftServices', `brand`, brandName));
      dispatch(change('GiftServices', `optionId`, defaultOptionId));
      dispatch(change('GiftServices', `message`, ''));
    }
    this.setState({ brandState: brandName });
  };

  handleAnalytics = () => {
    const { setClickAnalyticsDataGC, trackClickAnalytics } = this.props;
    const { orderItems } = this.state;
    const { CHECKOUT_PAGE, CHECKOUT_SHIPPING_PAGE } = CONSTANTS;
    setClickAnalyticsDataGC({
      customEvents: ['Checkout_Gift_Options_e10', 'event10'],
      eventName: 'select gift option',
      products: orderItems,
      clickEvent: true,
    });
    trackClickAnalytics({
      name: 'gift_options',
      module: 'checkout',
      pageData: {
        pageName: CHECKOUT_SHIPPING_PAGE,
        pageSection: CHECKOUT_PAGE,
        pageSubSection: CHECKOUT_PAGE,
        pageType: CHECKOUT_PAGE,
        pageShortName: CHECKOUT_SHIPPING_PAGE,
      },
    });
  };

  getGiftServicesDetailsModalContent = () => {
    const { fetchGiftDetailsContentModuleX } = this.props;
    const labels = getDynamicLabelValues('checkout.shipping');
    const cvvContentId = labels && labels?.referred;
    if (cvvContentId) {
      fetchGiftDetailsContentModuleX(cvvContentId);
    }
  };

  isShowSPCGiftService = (giftWrapOptions, spc) => giftWrapOptions && spc;

  render() {
    const {
      detailsRichTextTcp,
      formName,
      formSection,
      dispatch,
      giftWrapOptions,
      giftWrap,
      currencySymbol,
      detailsRichTextGymboree,
      setClickAnalyticsDataGC,
      cartOrderItems,
      fetchNeedHelpContent,
      getGiftServicesContentTcpInfo,
      getGiftServicesContentGymInfo,
      deselectCallback,
      giftServicesInputs,
      savedGiftService,
      spc,
      giftDetailRichText,
      updateGiftServices,
      setUpdateGiftServices,
      giftDetailsSnjRichText,
      giftDetailsGymRichText,
      giftDetailsPjpRichText,
      submitSaveAndContinueShipping,
      supressGiftServicesOnLoadApp,
      isSnjPjpGiftServicesDisabled,
      isGcEnabledOnBagSection,
      isMixedOrder,
      sfsError,
      setSFSErrorsActn,
      dispatchGiftFormFieldChange,
      addSFSItemsToSFLActn,
    } = this.props;
    if (!giftWrapOptions || isCanada()) return null;

    const optionId = giftWrap && !updateGiftServices ? giftWrap.get('optionId') : '';
    const message = giftWrap && !updateGiftServices ? giftWrap.get('message') : '';
    const hasGiftWrapping = giftWrap && !!giftWrap.size && !updateGiftServices;
    const brand = giftWrap ? giftWrap.get('brand') : '';
    const SelectedBrand = this.getBrandForGiftServices();
    const updateLabels = {
      DETAILS_RICH_TEXT_TCP: detailsRichTextTcp,
      DETAILS_RICH_TEXT_GYM: detailsRichTextGymboree,
    };
    return (
      <>
        {this.isShowSPCGiftService(giftWrapOptions, spc) ? (
          <GiftServicesSPC
            labels={updateLabels}
            formName={formName}
            dispatch={dispatch}
            isGiftServicesChecked={giftWrap && giftWrap.size}
            formSection={formSection}
            giftWrapOptions={giftWrapOptions}
            initialValues={{ optionId, message, hasGiftWrapping, brand }}
            currencySymbol={currencySymbol}
            handleToggle={this.handleToggle}
            SelectedBrand={SelectedBrand}
            setClickAnalyticsDataGC={setClickAnalyticsDataGC}
            cartOrderItems={cartOrderItems}
            handleAnalytics={this.handleAnalytics}
            fetchNeedHelpContent={fetchNeedHelpContent}
            getGiftServicesContentTcpInfo={getGiftServicesContentTcpInfo}
            getGiftServicesContentGymInfo={getGiftServicesContentGymInfo}
            deselectCallback={deselectCallback}
            giftServicesInputs={giftServicesInputs}
            savedGiftService={savedGiftService}
            spc={spc}
            giftDetailRichText={giftDetailRichText}
            updateGiftServices={updateGiftServices}
            setUpdateGiftServices={setUpdateGiftServices}
            giftDetailsGymRichText={giftDetailsGymRichText}
            giftDetailsSnjRichText={giftDetailsSnjRichText}
            giftDetailsPjpRichText={giftDetailsPjpRichText}
            submitSaveAndContinueShipping={submitSaveAndContinueShipping}
            getGiftServicesDetailsModalContent={this.getGiftServicesDetailsModalContent}
            supressGiftServicesOnLoadApp={supressGiftServicesOnLoadApp}
            isSnjPjpGiftServicesDisabled={isSnjPjpGiftServicesDisabled}
            isGcEnabledOnBagSection={isGcEnabledOnBagSection}
            isMixedOrder={isMixedOrder}
            sfsError={sfsError}
            setSFSErrors={setSFSErrorsActn}
            dispatchGiftFormFieldChange={dispatchGiftFormFieldChange}
            addSFSItemsToSFL={addSFSItemsToSFLActn}
          />
        ) : (
          <GiftServices
            labels={updateLabels}
            formName={formName}
            dispatch={dispatch}
            isGiftServicesChecked={giftWrap && giftWrap.size}
            formSection={formSection}
            giftWrapOptions={giftWrapOptions}
            initialValues={{ optionId, message, hasGiftWrapping, brand }}
            currencySymbol={currencySymbol}
            handleToggle={this.handleToggle}
            SelectedBrand={SelectedBrand}
            setClickAnalyticsDataGC={setClickAnalyticsDataGC}
            cartOrderItems={cartOrderItems}
            handleAnalytics={this.handleAnalytics}
            fetchNeedHelpContent={fetchNeedHelpContent}
            getGiftServicesContentTcpInfo={getGiftServicesContentTcpInfo}
            getGiftServicesContentGymInfo={getGiftServicesContentGymInfo}
            deselectCallback={deselectCallback}
            giftServicesInputs={giftServicesInputs}
            savedGiftService={savedGiftService}
            spc={spc}
          />
        )}
      </>
    );
  }
}
GiftServicesContainer.propTypes = {
  formName: PropTypes.string,
  formSection: PropTypes.string,
  dispatch: PropTypes.func,
  detailsRichTextTcp: PropTypes.shape.isRequired,
  giftWrapOptions: PropTypes.shape.isRequired,
  giftWrap: PropTypes.shape.isRequired,
  currencySymbol: PropTypes.string,
  detailsRichTextGymboree: PropTypes.shape.isRequired,
  setClickAnalyticsDataGC: PropTypes.func.isRequired,
  cartOrderItems: PropTypes.shape([]).isRequired,
  trackClickAnalytics: PropTypes.func.isRequired,
  fetchNeedHelpContent: PropTypes.func.isRequired,
  getGiftServicesContentTcpInfo: PropTypes.shape({}).isRequired,
  getGiftServicesContentGymInfo: PropTypes.shape({}).isRequired,
  giftServicesInputs: PropTypes.shape({}).isRequired,
  deselectCallback: PropTypes.func,
  savedGiftService: PropTypes.shape({}).isRequired,
  spc: PropTypes.bool.isRequired,
  fetchGiftDetailsContentModuleX: PropTypes.func.isRequired,
  giftDetailRichText: PropTypes.string.isRequired,
  updateGiftServices: PropTypes.bool.isRequired,
  supressGiftServicesOnLoadApp: PropTypes.bool,
};
GiftServicesContainer.defaultProps = {
  dispatch: () => {},
  formName: '',
  formSection: '',
  currencySymbol: '$',
  deselectCallback: () => {},
  supressGiftServicesOnLoadApp: false,
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setClickAnalyticsDataGC: (payload) => {
      dispatch(setClickAnalyticsData(payload));
    },
    trackClickAnalytics: (payload) => {
      dispatch(trackClick(payload));
    },
    fetchNeedHelpContent: (contentIds) => {
      dispatch(BAG_PAGE_ACTIONS.fetchModuleX(contentIds));
    },
    fetchGiftDetailsContentModuleX: (payload) => {
      dispatch(fetchGiftDetailsModalContentModuleX(payload));
    },
    addSFSItemsToSFLActn: (payload, navigation) => {
      dispatch(addSFSItemsToSFL(payload, navigation));
    },
    setSFSErrorsActn: (payload) => {
      dispatch(setSFSErrors(payload));
    },
  };
};

export const mapStateToProps = (state) => ({
  detailsRichTextTcp: getDetailsContent(state, BRANDS.TCP.toUpperCase()),
  detailsRichTextGymboree: getDetailsContent(state, BRANDS.GYM.toUpperCase()),
  giftWrapOptions: getGiftWrapOptions(state),
  giftWrap: getInitialGiftWrapOptions(state),
  currencySymbol: getCurrencySymbol(state),
  cartOrderItems: BagPageSelector.getOrderItems(state) || [],
  giftServicesInputs: getFormValues('GiftServices')(state),
  getGiftServicesContentTcpInfo: BagPageSelector.getGiftServicesContentInfo(
    BRANDS.TCP.toUpperCase()
  ),
  getGiftServicesContentGymInfo: BagPageSelector.getGiftServicesContentInfo(
    BRANDS.GYM.toUpperCase()
  ),
  isShippingCheckboxSelected: getShippingSelected(state),
  giftDetailRichText: giftDetailsModalModuleXContent(state),
  giftDetailsSnjRichText: giftDetailsSnjModalModuleXContent(state),
  giftDetailsGymRichText: giftDetailsGymModalModuleXContent(state),
  giftDetailsPjpRichText: giftDetailsPjpModalModuleXContent(state),
  supressGiftServicesOnLoadApp: supressGiftServicesOnLoad(state),
  isSnjPjpGiftServicesDisabled: getIsSnjPjpBrandGiftServicesDisabled(state),
  isMixedOrder: isMixedOrderStatus(state),
  sfsError: getSfsError(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(GiftServicesContainer);
